import styled from '@emotion/styled';

const FooterStyles = styled.div`
  font-size: 14px;
  padding: 1rem;
  display: grid;
  justify-content: center;
  text-align: center;
  grid-gap: 0.5rem;
`;

export default FooterStyles;
